import '/assets/styles/sections/page-header.scss';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Placeholder from '/views/partials/placeholder';

// Context
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useTranslation } from '/utilities/i18n';
import classNames from 'classnames';

const PageHeader = ({
	title,
	subtitle,
	backLink,
	backLinkText,
	backLinkRedirect,
	backLinkParams,
	backLinkIcon,
	backLinkOnClick,
	icon,
	disabled,
	className,
}) => {
	const { goBack, redirect } = useNavigator();
	const { t } = useTranslation();

	const backLinkClick = () => {
		if (backLinkOnClick) {
			backLinkOnClick();
		} else if (backLinkRedirect) {
			redirect(backLink, backLinkParams);
		} else {
			goBack(backLink);
		}
	};

	return (
		<section
			className={classNames('section', 'page-header', className, {
				'has-subtitle': !!subtitle || subtitle === false,
			})}
		>
			{!!(title || title === false || subtitle || subtitle === false || icon) && (
				<div className="header-textcontent">
					{icon && <Icon name={icon} className="header-icon" />}
					{!!(title || title === false || subtitle || subtitle === false) && (
						<div className="textcontent-titlewrap">
							{title && <strong className="header-title">{title}</strong>}
							{title === false && <Placeholder primary className="header-title" />}
							{subtitle && <span className="header-subtitle">{subtitle}</span>}
							{subtitle === false && <Placeholder primary className="header-subtitle" />}
						</div>
					)}
				</div>
			)}

			{!!(backLink || backLinkOnClick) && (
				<button disabled={disabled} onClick={backLinkClick} className="header-closebtn">
					<Icon name={backLinkIcon ?? (backLinkText ? 'angle-left' : 'close')} />
					{backLinkText && (
						<span className="closebtn-text">{backLinkText === true ? t('Geri') : backLinkText}</span>
					)}
				</button>
			)}
		</section>
	);
};

export default PageHeader;
